/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import { GET_RECENT_EMAILS_EDITED } from '../constants';

function cleanData(emails) {
  if (emails) {
    return emails
      .map(({ campaigns, id, data = { email: { legacy: {} } }, modifiedBy = {}, modifiedDate, name, objectID }) => ({
        campaigns,
        id,
        legacyId: data.email.legacy.legacyId,
        modifiedByName: modifiedBy.name,
        modifiedDate: Date.parse(modifiedDate.replace('-06:00', '')),
        name,
        key: objectID,
      }))
      .slice(0, 5);
  }

  return emails;
}

let exampleState = [];
if (process.env.NODE_ENV !== 'production') {
  exampleState = cleanData([
    {
      id: 25193,
      customerKey: 'f38c0ca9-ecfe-421a-b68e-ad6fc4a456a7',
      objectID: '254e37a4-f26b-46fb-9351-24176ba03857',
      assetType: {
        id: 207,
        name: 'templatebasedemail',
        displayName: 'Template-Based Email',
      },
      name: 'Test Email 2',
      description: '',
      createdDate: '2016-09-21T08:05:09.537-06:00',
      createdBy: {
        id: 10808992,
        email: 'mbeard@salesforce.com',
        name: 'Matt Beard',
        userId: '10808992',
      },
      modifiedDate: '2016-10-12T13:41:37.073-06:00',
      modifiedBy: {
        id: 10770152,
        email: 'mbeard@salesforce.com',
        name: 'uxds user',
        userId: '10770152',
      },
      enterpriseId: 10733704,
      memberId: 10733704,
      campaigns: [
        {
          campaignId: 2926,
          campaignAssociationId: 10548,
        },
      ],
      status: {
        id: 1,
        name: 'Draft',
      },
      approvalStatus: {
        id: 4,
        name: 'Approved',
        displayName: 'Approved',
      },
      thumbnailUrl: '/v1/assets/25193/thumbnail',
      options: {
        characterEncoding: 'us-ascii',
      },
      data: {
        email: {
          legacy: {
            legacyId: 69754,
            legacyKey: 'f38c0ca9-ecfe-421a-b68e-ad6fc4a456a7',
            legacyType: 'email',
            legacyCategoryId: 443237,
          },
        },
      },
      modelVersion: 1,
    },
    {
      id: 14403,
      customerKey: 'dd153d8e-51a8-4ae8-9db8-88c653548dc7',
      objectID: 'cd56af52-6b1e-4472-a9b9-1f03fcea80c1',
      assetType: {
        id: 208,
        name: 'htmlemail',
        displayName: 'HTML Email',
      },
      name: 'Welcome: Getting Started',
      description: 'sfdg',
      createdDate: '2016-06-30T15:17:44.333-06:00',
      createdBy: {
        id: 10770152,
        email: 'mbeard@salesforce.com',
        name: 'uxds team',
        userId: '10770152',
      },
      modifiedDate: '2016-08-19T09:54:34.237-06:00',
      modifiedBy: {
        id: 10770152,
        email: 'mbeard@salesforce.com',
        name: 'uxds user',
        userId: '10770152',
      },
      enterpriseId: 10733704,
      memberId: 10733704,
      campaigns: [
        {
          campaignId: 2926,
          campaignAssociationId: 8691,
        },
      ],
      status: {
        id: 2,
        name: 'Published',
      },
      thumbnailUrl: '/v1/assets/14403/thumbnail',
      options: {
        characterEncoding: 'us-ascii',
        generateFrom: '',
      },
      data: {
        email: {
          legacy: {
            legacyId: '61470',
            legacyKey: 'dd153d8e-51a8-4ae8-9db8-88c653548dc7',
            legacyType: 'email',
            legacyCategoryId: '443237',
          },
        },
      },
      generateFrom: '',
      modelVersion: 1,
    },
  ]);
}

export default function recentEmailsEdited(state = exampleState, action) {
  switch (action.type) {
    case GET_RECENT_EMAILS_EDITED: {
      let newState = state;

      if (action.error) {
        newState = [...state];
        newState.error = action.error;
      } else if (action.payload.response && action.payload.response.items) {
        newState = cleanData(action.payload.response.items);
      }

      return newState;
    }
    default: {
      return state;
    }
  }
}
